<lin-progress-bar [isShown]="isLoading"></lin-progress-bar>
<form [formGroup]="form" class="chat-create-form" [class.chat-create-form-disabled]="isLoading">
  <div class="modal-header">
    <mat-form-field class="search" appearance="fill">
      <input
        [(ngModel)]="searchValue"
        matInput
        formControlName="search"
        [placeholder]="'CLIENT.MESSENGER.CHAT_CREATE.PLACEHOLDER' | translate"
        autocomplete="off"
      />
      <mat-icon matPrefix svgIcon="search"></mat-icon>
      <mat-icon *ngIf="searchValue" matSuffix class="clear-button" svgIcon="close" (click)="searchValue=''"></mat-icon>
    </mat-form-field>

    <div *ngIf="selectedUsers.size" class="existing-chat-info">
      <mat-form-field *ngIf="isGroupChat" class="chat-title">
        <mat-label>{{ 'CLIENT.MESSENGER.CHAT_DETAILS.GROUP_NAME' | translate }}</mat-label>
        <input matInput formControlName="chatTitle" />
      </mat-form-field>

      <div class="existing-chat-users" linPerfectScrollbar>
        <div
          *ngFor="let chatUser of selectedUsers | keyvalue"
          class="existing-chat-user"
          matTooltip="{{ chatUser.value.fullName + (isChatLeader(chatUser.value.id) ? ' (' + ('CLIENT.MESSENGER.CHAT_DETAILS.CHAT_LEADER' | translate) + ')' : '') }}"
        >
          <lin-avatar
            [source]="chatUser.value.picture"
            [name]="chatUser.value.name"
            [surName]="chatUser.value.surname"
            [size]="AvatarSize.mds"
          ></lin-avatar>
          <div class="user-status">
            <div class="status" [ngClass]="{ 'online': chatUser.value.networkStatus }"></div>
          </div>
          <mat-icon *ngIf="isChatLeader(chatUser.value.id)" svgIcon="crown" class="crown"></mat-icon>
          <mat-icon
            *ngIf="chatUser.value.id !== currentUser.id && canKick"
            svgIcon="close"
            class="close"
            (click)="selectedUsers.delete(chatUser.value.id)"
          ></mat-icon>
        </div>
      </div>
    </div>
  </div>

  <div class="users-list" linPerfectScrollbar>
    <div *ngFor="let user of filteredUserList" class="user" (click)="handleUserClick(user)">
      <div class="user-wrapper">
        <div class="user-avatar">
          <lin-avatar [source]="user.picture" [name]="user.name" [surName]="user.surname" [size]="AvatarSize.mds"> </lin-avatar>
          <div class="user-status">
            <div class="status" [ngClass]="{ 'online': !!user.networkStatus }"></div>
          </div>
        </div>
        <div class="user-name">{{ user.fullName }}</div>
        <div class="user-icons">
          <div *ngIf="isChatLeader(user.id)" class="user-leader" [matTooltip]="'CLIENT.MESSENGER.CHAT_DETAILS.CHAT_LEADER' | translate">
            <mat-icon svgIcon="crown"></mat-icon>
          </div>
          <div class="user-selected">
            <mat-icon *ngIf="selectedUsers.has(user.id)" svgIcon="check_circle"></mat-icon>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="chat-create-form-bottom">
    <button
      mat-raised-button
      color="accent"
      class="btn btn-primary"
      (click)="dialogData?.chat?.id ? updateChat() : createChat()"
      [disabled]="!selectedUsers.size"
    >
      {{ (dialogData?.chat?.id ? 'CLIENT.MESSENGER.CHAT_CREATE.EDIT' : 'CLIENT.MESSENGER.CHAT_CREATE.SUBMIT') | translate }}
    </button>
  </div>
</form>
